import {Button, Stack} from '@mui/joy';
import React, {type RefObject} from 'react';
import {useParams as useRouteParams} from 'react-router-dom';
import {useReactToPrint} from 'react-to-print';

const SurgicalPlan = ({
	componentRef,
}: {
	componentRef: RefObject<HTMLDivElement>;
}) => {
	const {scanId} = useRouteParams<{scanId: string}>();

	const handlePrint = useReactToPrint({
		content() {
			if (componentRef?.current) {
				return componentRef.current;
			}

			return null;
		},
		documentTitle: `Surgical Plan - ${scanId}`,
	});

	return (
		<Stack spacing={4}>
			<Button onClick={handlePrint}>Print Surgical Plan</Button>
		</Stack>
	);
};

export default SurgicalPlan;
